module.exports = __webpack_public_path__ + "img/sponsor-carousel-reid.9acb5c25.jpg";